export function getDownloadSubtitle(
  countryProps,
  selectedYear,
  language,
  ...additional
) {
  if (countryProps === undefined) return "";

  let subtitle =
    language === "en"
      ? countryProps.country_text_en
      : countryProps.country_text;

  if (selectedYear !== "HIST") subtitle += ", " + selectedYear;

  additional.forEach((add) => {
    if (add) subtitle += ", " + add;
  });

  return subtitle;
}
